import React, { useState, useRef, useEffect } from "react";
import Countdown from "react-countdown";
import { useMutation, useQuery } from "react-query";
import { callQueryapi } from "../../services/http/callapi";
import {
  RN_SENDOTP_API,
  GET_RN_USER_DETAILS,
} from "../../services/common/endpoints";
import { LOGIN_SSO_URL } from "../../services/common/endpoints";
import HeaderComponent from "../../components/header/index";
import { Navigate, useFetcher, useLocation, useNavigate } from "react-router-dom";
import BottomModalComponent from "./../../components/common/bottom-modal";
import { useSelector } from "react-redux";
import Loadingcomponent from "../../components/loader/loadingcomponent";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { GetCacheKey, loginencrypt, getItemOfSessionStorage, consoleLog } from "../../services/common/utils";
import { EndPointUserDetails } from "../../services/common/endpoints";
import {
  setcustomerprofile,
  setrnuserdetails,
  setSelectedNumber,
  setLoginType,
  setSocialMediaType,
  setRatePlanType, 
  setGTMLoginFlag,
  setSocialLoginType,
  setISB2BCPRNumber,
  setUserLoggedInNumber
} from "../../reducer/actions";
import { settoken } from "../../reducer/actions";
import { setItem } from "../../services/common/utils";
import { TOKEN_ID, SELECTED_LANG } from "../../services/common/Constants";
import { validateEmail } from "../../services/common/utils";
import { getPaymentResponsibleValue, isB2BCPRNumber } from "../../services/common/CommonUtils";
import {
  RecordScreenEvent,
  RecordlogEvents,
  setRecordUserProperty,
} from "../../../src/analytics/RecordEvents";
import {
    LoginSocialGoogle,
    LoginSocialFacebook,
  } from "reactjs-social-login";
import AppleLogin from "react-apple-login";
import jwt_decode from "jwt-decode";
import {GTMScreenView, GTM_Login, GTM_OtpValidation} from "../../../src/analytics/GoogleTagManager";
import { setItemInSessionStorage } from "../../services/common/utils";
import {CT_Events} from '../../../src/analytics/CTEvents';

const OTPLoginVerification = () => {
  const [enteredValue, setEnteredValue] = useState("");
  const [iserror, setIsError] = useState(false);
  const [pwd, setpwd] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [showResendOtp, setshowResendOtp] = useState(false);
  const [msisdn, setMsisdn] = useState("");
  const [transId, setTransId] = useState("");
  const [isepd, setIsEpd] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [respMessage, setRespMesssage] = useState("");
  const [tokenId, setTokenId] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordInput, setPasswordInput] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const [loginid, setloginid] = useState("");
  const [otp, setOtp] = useState("");
  const [countdownIndex, setCountdownIndex] = useState(1);
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const userdata = useSelector((state) => state?.userdata?.value?.rnuserdetails);
  const [countdown, setCountDown] = useState(Date.now() + 42000);
  const [requestType, setRequestType] = useState(false);
  const [eyeIcon, setEyeIcon] = useState("password");
  const [password, setPassword] = useState("");
  const [socialMedia, setSocialMedia] = useState();
  const [socialType,setsocialtype] = useState("");
  const loginmsisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  
  const changeField = () => {
    if(flag){
      optLogin("otpRequest");
    }
    setFlag(!flag);
  };
  const { t } = useTranslation();
  const navigate = useNavigate();
  const passwordRef = useRef("");
  const location = useLocation();
  const dispatch = useDispatch();
  const [flag, setFlag] = useState(!(location?.state?.epd));
  const { CT_OtpVerification } = CT_Events();
  const rnuserdetails = useQuery(
    [
      GetCacheKey("GET_RN_USER_DETAILS"),
      EndPointUserDetails.url,
      EndPointUserDetails.data,
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
      enabled: loggedIn,
    }
  );
  const userDetailsApi = useQuery(
    [
      GetCacheKey("GET_USER_DETAILS"),
      "customerprofile/get",
      { source: "homepage", sec: "splash" },
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
      enabled: loggedIn,
    }
  );
  const otpChange = (e) => {
    const value = e?.target?.value;
    if (value?.length <= 4 && value?.match(/^[0-9]*$/)) {
      setOtp(value);
    }
    if (value?.length < 4) {
      setDisabledButton(true);
    } else {
      setDisabledButton(false);
    }
  };

  const validateLoginUrl = useMutation(
    (req) => callQueryapi({ queryKey: [{}, LOGIN_SSO_URL, req] }),
    {
      onSuccess: async (udata, variables, context) => {
        try {    
          if (
            udata != null &&
            udata.data != null &&
            udata.data.response != null &&
            udata.data.response.tokenid != null
          ) {
            dispatch(settoken(udata.data.response.tokenid));
            setItem(TOKEN_ID, udata.data.response.tokenid);
            try {
              global.logintype = "msisdn";
            } catch (e) { }
            try { dispatch(setLoginType("msisdn"));
                  // setsocialtype("msisdn");
          } catch { }
            setItemInSessionStorage("loginStatus", udata.data.message)
            setLoggedIn(true);
          } else if (udata?.data?.status == "-1") {
            // console.log(udata?.data?.message);
            setPassword("")
            setShowModal(true);
            setshowResendOtp(false)
            setFlag(true)
            setRespMesssage(udata?.data?.message);
            return false;
          } else {
            setShowModal(true);
            setRespMesssage(t("sww"));
            return false;
          }
        } catch (error) {
          // console.log(error);
        }
      },
      onError: (uerror, variables, context) => {
        // console.log("Error-----------", uerror);
      },
    }
  );
  const passwordChange = (e) => {
    const passValue = e?.target?.value;
    setPassword(passValue);
    if (passValue?.length >= 8 && passValue?.length <= 20) {
      setpwd(passValue);
    }
    if (passValue?.length < 8) {
      setDisabledButton(true);
    } else {
      setDisabledButton(false);
    }
  };

  let sendOtpReqObj = {};
  if (location?.state?.loginmode === "msisdn") {
    sendOtpReqObj.type = "sms";
    sendOtpReqObj.msisdn = `965${loginid}`;
    sendOtpReqObj.action = "auth";
  } else {
    sendOtpReqObj.type = "email";
    sendOtpReqObj.email = `965${loginid}`;
    sendOtpReqObj.action = "forgotpwd";
  }

  const sendotp = useQuery(["", "/v6/api/sso/rnsendotp", sendOtpReqObj, {}], {
    retry: false,
    retryOnMount: false,
    enabled: false,
    onSuccess: (res) => {
      if (res?.data?.status == "0") {
        if (res?.data?.response) {
          const _transId = res?.data?.response?.transid;
          navigate("/email-verification?headerText=one_time_password", {
            state: {
              emailId: loginid,
              transId: _transId,
              loginmode: location?.state?.loginmode || "",
            },
          });
        } else {
          // setApiMessage(res?.data?.message);
          return false;
        }
      } else {
        // setApiMessage(res?.data?.message);
        return false;
      }
    },
    onerror: (err) => {
      consoleLog(err);
      return false;
    },
  });

  const otpRequest = () => {
    sendotp.refetch();
  };
  useEffect(() => {
    if (userDetailsApi.isSuccess && userDetailsApi?.data?.data) {
      dispatch(setcustomerprofile(userDetailsApi?.data?.data?.response));
      setItemInSessionStorage("Customerid",userDetailsApi?.data?.data?.response?.CustomerID);
      try{
        var _isB2BCpr = isB2BCPRNumber(userDetailsApi?.data?.data?.response);
        dispatch(setISB2BCPRNumber(_isB2BCpr));
      }catch{}
    }
    if (rnuserdetails.isSuccess && rnuserdetails?.data?.data) {
      dispatch(setrnuserdetails(rnuserdetails?.data?.data?.response));
      try {
        let _msisdn = "";
        if (rnuserdetails?.data?.data?.response?.msisdn && rnuserdetails?.data?.data?.response?.msisdn.length == 11)
          _msisdn = rnuserdetails?.data?.data?.response?.msisdn.slice(3);
        else
          _msisdn = rnuserdetails?.data?.data?.response?.msisdn
          try{
          if(_msisdn == null || _msisdn == undefined || _msisdn == "" || _msisdn == "undefined"){
            if (userDetailsApi?.data?.data?.response?.Msisdn && userDetailsApi?.data?.data?.response?.Msisdn.length == 11)
            _msisdn = userDetailsApi?.data?.data?.response?.Msisdn.slice(3);
          else
            _msisdn = userDetailsApi?.data?.data?.response?.Msisdn
          }
        }catch{}
        dispatch(setSelectedNumber(_msisdn));
        dispatch(setUserLoggedInNumber(_msisdn));
      } catch (e) { }
    }
    if (rnuserdetails?.isSuccess && userDetailsApi?.isSuccess) {
      try {
        global.userdetails = rnuserdetails?.data?.data?.response;
        //console.log("global.userdetails:"+JSON.stringify(global.userdetails)+"")
        global.rateplantype = userDetailsApi?.data?.data?.response.RatePlanType;
        try {
          dispatch(
            setRatePlanType(userDetailsApi?.data?.data?.response?.RatePlanType)
          );
        } catch {}
      } catch (e) { }
      try {
        setPropertyCT(userDetailsApi?.data?.data);
        loginEventCT(userDetailsApi?.data?.data);
      } catch (e) { }
      navigate("/home/index");
    }
  }, [
    userDetailsApi?.data?.data,
    userDetailsApi.isSuccess,
    rnuserdetails?.data?.data,
    rnuserdetails.isSuccess,
  ]);

  // console.log(location.state.msisdn, "location");
  useEffect(() => {
    setMsisdn(location.state.msisdn);
    setTransId(location.state.transId);
    setIsEpd(location.state.epd);
    setEnteredValue(location.state.msisdn);
    setloginid(location.state.msisdn);
    if(location?.state?.message){
      setShowModal(true);
      setRespMesssage(location?.state?.message);
    }
  }, [location]);
  const otplogin = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, RN_SENDOTP_API, req],
      }),
    {
      onSuccess: async (udata, variables, context) => {
        // console.log("udata", udata);
        try {
          if (udata?.data != null && udata?.data?.status == "0") {
            const transId_1 = udata?.data?.response?.transid;
            setTransId(transId_1);
            setShowModal(true);
            setRespMesssage(udata?.data?.message);
            // console.log(transId_1);
            setshowResendOtp(false);
            let mobileno= udata?.data?.response?.mobileno;
            let email = udata?.data?.response?.email;
            setsocialtype(mobileno == "" ? email : mobileno)
            onClickReset();
          } else if (udata?.data?.status == "-1") {
            setShowModal(true);
            setRespMesssage(udata?.data?.message);
            return false;
          } else {
            setShowModal(true);
            setRespMesssage(t("sww"));
            return false;
          }
        } catch (e) {
          // console.log(e);
        }
      },
      onError: (uerror, variables, context) => {
        // console.log("-----_Error", uerror);
        setShowModal(true);
        setRespMesssage(t("sww"));
      },
    }
  );

  //calling the OptLogin
  const optLogin = (reqType) => {
    setRequestType(reqType);
    try {
      let validemail = validateEmail(loginid);
      let isnum = /^\d+$/.test(enteredValue);
      let parametrs = {};
      if (isnum) {
        setsocialtype("msisdn")
        parametrs = {
          type: "sms",
          msisdn: "965" + location.state.msisdn,
          action: "auth",
        };
      } else {
        setsocialtype("email")
        parametrs = {
          type: "email",
          action: "auth",
          email: location.state.email,
        };
      }
      setCountDown(Date.now() + 42000)
      otplogin.mutate(parametrs);
      setShowButton(true);
    } catch (e) {
      // console.log(e);
    }
  };
  const validateOtp = useMutation(
    (req) => callQueryapi({ queryKey: [{}, "sso/rnvalidateotp", req] }),
    {
      onSuccess: async (udata, variables, context) => {
        try {
          // console.log("-----Response", udata);
          // console.log("All variables....", variables);
          if (udata?.data != null && udata?.data?.status == "0") {
            const transId = udata?.data?.response?.transid;       
            // console.log(transId);
            // alert("Success");
            const token = udata?.data?.response?.tokenid;
            // console.log(token);
            setTokenId(token);
            dispatch(settoken(token));
            setItemInSessionStorage("loginStatus", udata?.data?.message)
            dispatch(setSelectedNumber(location?.state?.msisdn));
            dispatch(setUserLoggedInNumber(location?.state?.msisdn));
            setsocialtype("OTP")
            setLoggedIn(true);
            setItem(TOKEN_ID, token);
            try {
              global.logintype = "otp";
            } catch (e) { }
            try { dispatch(setLoginType("otp")); } catch { }
            try{
              GTM_OtpValidation("otp_login", msisdn, "msisdn", udata?.data?.message);
              CT_OtpVerification(msisdn);
            }catch{}
            // navigate("/home/index");
          } else if (udata?.data?.status == "-1") {
            setShowModal(true);
            setRespMesssage(udata?.data?.message);
            try{
              GTM_OtpValidation("otp_login", msisdn, "msisdn",  udata?.data?.message);
              CT_OtpVerification(msisdn);
            }catch{}
            return false;
          } else {
            setShowModal(true);
            setRespMesssage(t("sww"));
          }
        } catch (e) {
          // console.log(e);
          setShowModal(true);
          setRespMesssage(t("sww"));
        }
      },
      onError: (uerror, variables, context) => {
        setShowModal(true);
        setRespMesssage(t("sww"));

        if (passwordRef.current.value != 4) {
          setShowModal(true);
          setRespMesssage(t("sww"));
        }
      },
    }
  );
  const validateOtpParams = () => {
    try{
      localStorage.setItem("sl",location.state.msisdn)
      }
    catch{};
    try {
      let encPwd = loginencrypt(pwd);
      let parametrs = {};
      if (otp != null && otp != undefined && otp.length != 0) {
        parametrs = {
          transid: transId,
          otp: otp,
          type: "sms",
        };
        validateOtp.mutate(parametrs);
      } else {
        parametrs = {
          loginid: "965" + location.state.msisdn,
          loginmode: "msisdn",
          pwd: encPwd,
          socialid: "",
          RM: "1",
        };
        validateLoginUrl.mutate(parametrs);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  // Timer Logic
  const Ref = useRef(null);
  const [timer, setTimer] = useState("0:00s");

  //console.log("Timer has started ........");

  const startTimer = (e) => {
    let { total, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (minutes > 41 ? minutes : minutes) +
        ":" +
        (seconds > 9 ? seconds : "0" + seconds)
      );
    } else if (timer == 0) {
      return false;
    }
  };

  const clearTimer = (e) => {
    setTimer("0:42");
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    return {
      total,
      minutes,
      seconds,
    };
  };

  const getDeadTime = () => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 42);
    return deadline;
  };
  const onKeyPress = (e) => {
    if (e.which === 13) {
      validateOtpParams()
    }
  };
  useEffect(() => {
    clearTimer(getDeadTime());
    try {
      RecordScreenEvent('otp login', logintype, userdata);
    } catch (e) { }
    try{
      GTMScreenView("otp-login", location?.state?.msisdn, logintype)
    }catch{}
  }, []);

  useEffect(()=>{
    try{
     if(loggedIn == true){
       try{
        let socialmedia = (socialType === "gmail" || socialType === "Facebook" || socialType === "appleid") ? "social" : socialType;
        dispatch(setSocialLoginType(socialType));
        dispatch(setLoginType(socialmedia));
        dispatch(setGTMLoginFlag(true));
       }catch{}
      // GTM_Login("otp_login", loginmsisdn, (socialType === "gmail" || socialType === "Facebook" || socialType === "appleid") ? "social" : socialType, socialmedia);
      // dispatch(setLoginType(socialType))
    }
  }catch{}
 },[loggedIn])

  const onClickReset = () => {
    clearTimer(getDeadTime());
  };

  const countdownCompleted = () => {
    setshowResendOtp(true);
  };
  const countdownRenderer = ({ hours, minutes, seconds, completed }) => {
    // console.log(minutes)

    if (completed) {
      // setResendEnable(true);

      countdownCompleted();

      // Render a completed state

      return "";
    } else {
      // Render a countdown

      return (
        <span>
          {minutes}:{seconds > 9 ? seconds : `0${seconds}`}s
        </span>
      );
    }
  };

  const setPropertyCT = (data_sp) => {
    try {
      setRecordUserProperty({
        email: userdata?.email || "",
        name: userdata?.firstname,
        ContractID: data_sp?.response.ContractID,
        mobileNo: data_sp?.response.Msisdn,
        isdigital: data_sp?.response.IsDigitalCustomer,
        rateplantype: data_sp?.response.RatePlanType,
        custtype: data_sp?.response.Segment,
        language: getItemOfSessionStorage(SELECTED_LANG),
        voiceline: data_sp?.response.voiceline,
        rnuserdetails: userdata
      });
    } catch (e) { }
  };

  const eyeiconclick = () => {
    if(password?.length > 0){
      if (eyeIcon == "password") {
        setEyeIcon("text");
      } else {
        setEyeIcon("password");
      }
    }
  };

  const loginEventCT = (data_lg) => {
    global.loginEventCalled = "yes";
    try {
      RecordlogEvents("Login", {
        SSO:
          userdata === "" ||
            userdata === null ||
            userdata === "NULL" ||
            userdata === "null" ||
            userdata === undefined
            ? userdata?.msisdn
            : userdata?.email,
        "Login Type": logintype,
        IsDigital: data_lg?.response?.IsDigitalCustomer,
        PaymentResponsible: getPaymentResponsibleValue(data_lg?.response),
        RatePlanType: data_lg?.response?.RatePlanType,
        "Customer Type": data_lg?.response?.CustomerType,
        "Mobile Number": data_lg?.response?.Msisdn,
        language: getItemOfSessionStorage(SELECTED_LANG),
        status: "Success",
        "Status Description":
          data_lg.message != null && data_lg.message !== ""
            ? data_lg.message
            : data_lg.actualmessage,
      });
    } catch (e) { }
  };
  
  const toggleModal = () => {
    setShowModal(!showModal);
  };
  // if (
  //   validateLoginUrl.isLoading ||
  //   // otplogin.isLoading ||
  //   validateOtp.isLoading ||
  //   userDetailsApi.isLoading ||
  //   userDetailsApi.isFetching ||
  //   rnuserdetails.isLoading ||
  //   rnuserdetails.isFetching
  // ) {
  //   return <Loadingcomponent></Loadingcomponent>;
  // }

  const isApiCall = (validateLoginUrl.isLoading ||
  validateOtp.isLoading ||
  userDetailsApi.isLoading ||
  userDetailsApi.isFetching ||
  rnuserdetails.isLoading ||
  rnuserdetails.isFetching)

  return (
    <div>
      <HeaderComponent type={5} name={t("login")}></HeaderComponent>

      <section className="app_main_wrapper d-flex flex-column mt-60">
        <div className="bottom_bg_section">
          <div className="bottom_bg_section_container">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/assets_bg.jpg"}
              alt=""
              title=""
            />
          </div>
        </div>
        <div className="center_section">
          <div className="sec_top mt-160">
            <div className="pse_lg">
              <div className="form-group text-start mb-4">
                <label className="control-label">{t("mobilenumber")}</label>
                <input
                  readOnly={true}
                  value={location.state.msisdn || location.state.email}
                  type="text"
                  onChange={(e) => {
                    setEnteredValue(e.target.value);
                  }}
                  maxLength={8}
                  className="form-control"
                  placeholder=""
                />
              </div>
           
              {(location?.state?.rnRegisteredData?.epd === "T" ) ? (
                <>
                  {!flag ? (
                    <>
                      <div className="form-group">
                        <label className="control-label">{t("otp")}</label>
                        <div className="input_icon right-icon">
                          <input
                            onChange={otpChange}
                            type={passwordShown ? "number" : "password"}
                            inputMode="numeric"
                            value={otp}
                            className="form-control"
                            onKeyDown={(e) => onKeyPress(e)} 
                            placeholder=""
                          />
                        </div>
                      </div>

                      <div className="flex_grp_between mt-3">
                        <a
                          className={
                            showResendOtp || timer == "0:00"
                              ? "hyperlink hyperlink_sm enabled"
                              : "hyperlink hyperlink_sm disabled"
                          }
                          onClick={() => showResendOtp && optLogin("rotpRequest")}
                        >
                          {t("rotp")}
                        </a>
                        <p className="mb-0 primary-font primary_color font12">
                          {/* {showResendOtp || timer == "0:00" ? "" : timer + "s"} */}
                          {!showResendOtp && <Countdown
                            key={countdownIndex}
                            date={countdown}
                            renderer={countdownRenderer}
                          ></Countdown>}
                        </p>
                      </div>
                      {(requestType === "rotpRequest" && otplogin?.isLoading)  ? <Loadingcomponent></Loadingcomponent> : ""}
                    </>
                  ) : (
                    <div className="form-group text-start">
                      <label className="control-label">{t("password")}</label>
                      <div className="input_icon right-icon">
                        <input
                          onChange={passwordChange}
                          type={eyeIcon}
                          className="form-control"
                          placeholder=""
                          maxLength={20}
                           onKeyDown={(e) => onKeyPress(e)} 
                        />
                        <button 
                          onClick={eyeiconclick}
                        >
                          <img
                            src={
                              eyeIcon == "password"
                                  ? process.env.PUBLIC_URL +
                                  "/assets/images/password_hide_dark.svg"
                                  : process.env.PUBLIC_URL +
                                  "/assets/images/password_show_dark.svg"
                              }
                            alt=""
                            title=""
                          />
                        </button>
                      </div>

                      <div className="flex_grp_end mt-3">
                        <div
                          onClick={() => {
                          otpRequest();
                          }}
                          className="hyperlink hyperlink_sm"
                        >
                          {t("forgotpassword")}
                        </div>
                      </div>
                    </div>
                  )}
                     <div className="or_sepatator mt-30 mb-4">
                      <span></span>
                      <p className="mb-0"> {t("or")}</p>
                      <span></span>
                    </div>
                  <button
                    className={`custom_btn custom_btn_primary_outline btn_block mt-20 mb-4 ${(otplogin?.isLoading && requestType === "otpRequest") ? 'disabled_border' : ''}`}
                    data-bs-toggle="modal"
                    data-bs-target=".popup2"
                    onClick={() => {
                      changeField();
                    }}
                    disabled={(otplogin?.isLoading && requestType === "otpRequest")}
                  >
                    {flag ? t("otp") : ((otplogin?.isLoading && requestType === "otpRequest")) ?<Loadingcomponent></Loadingcomponent> :  t("enterpwd")}
                  </button>
                </>
              ) : (
                <>
                  <div className="form-group">
                    <label className="control-label">{t("otp")}</label>
                    <div className="input_icon right-icon">
                      <input
                        onChange={otpChange}
                        type={passwordShown ? "number" : "password"}
                        inputMode="numeric"
                        value={otp}
                        className="form-control"
                        placeholder=""
                        onKeyDown={(e) => onKeyPress(e)} 
                      />
                    </div>
                  </div>

                  <div className="flex_grp_between mt-3">
                    <a
                      className={
                        showResendOtp || timer == "0:00"
                          ? "hyperlink hyperlink_sm enabled"
                          : "hyperlink hyperlink_sm disabled"
                      }
                      onClick={() => {showResendOtp && optLogin("rotpRequest")}}
                    >
                      {t("rotp")}
                    </a>
                    <p className="mb-0 primary-font primary_color font12">
                      {/* {showResendOtp || timer == "0:00" ? "" : timer + "s"} */}
                      <Countdown
                        key={countdownIndex}
                        date={countdown}
                        renderer={countdownRenderer}
                      ></Countdown>
                    </p>
                  </div>
                </>
              )}
            </div>     
            {(location?.state?.rnRegisteredData?.epd === "F" && (location?.state?.rnRegisteredData?.sga === "T" || location?.state?.rnRegisteredData?.sfa === "T" || location?.state?.rnRegisteredData?.saa === "T" )) &&
              <div className="or_sepatator mt-30 mb-4">
                <span></span>
                <p className="mb-0"> {t("or")}</p>
                <span></span>
              </div>
            }

            <div className="pse_lg">
                {/* or seperator and login content */}
                {(location?.state?.rnRegisteredData?.sga === "T" ||  location?.state?.rnRegisteredData?.sfa === "T"  || location?.state?.rnRegisteredData?.saa === "T") &&
                  <div className="support_text mb-0"><p>{t("socialMessage")}</p></div>
                }

                <div className="center_section">
                  {/* login with google account */}
                  {location?.state?.rnRegisteredData?.sga === "T" &&(
                      <LoginSocialGoogle
                          client_id={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                          scope='email profile'
                          onResolve={(resGoogle) => {
                          // console.log("resGoogle", resGoogle);

                          const requestData = {
                              loginid: resGoogle?.data?.email,
                              loginmode: "email",
                              socialmediatype: "gmail",
                              pwd: "",
                              socialid: resGoogle?.data?.sub,
                              RM: "1",
                          };
                          setsocialtype("gmail");
                          // console.log('requestData', requestData);
                          validateLoginUrl.mutate(requestData);
                          //   socialSignIn.mutate(requestData);
                          }}
                          onReject={(err) => {
                          console.log("err", err);
                          }}
                      >
                          <button className="social_btn gmail_btn mb-3">
                          <img
                              src={process.env.PUBLIC_URL + "/assets/images/gmail.png"}
                              alt=""
                              title=""
                          />
                          {t("cwg")}
                          </button>
                      </LoginSocialGoogle>
                  )}

                  {/* login with facebook account */}
                  {location?.state?.rnRegisteredData?.sfa === "T" &&(
                      <LoginSocialFacebook
                          appId={process.env.REACT_APP_FB_APP_ID}
                          onResolve={(resolveRes) => {
                              // console.log("resolveRes", resolveRes);
                              const requestData = {
                              loginid: resolveRes?.data?.email,
                              loginmode: "email",
                              socialmediatype: "Facebook",
                              pwd: "",
                              socialid: resolveRes?.data?.userID,
                              RM: "1",
                              };
                              setsocialtype("Facebook");
                              validateLoginUrl.mutate(requestData);
                          }}
                          onReject={(rejectRes) => {
                              console.log("rejectRes", rejectRes);
                          }}
                          >
                          <button className="social_btn facebook_btn">
                              <img
                              src={
                                  process.env.PUBLIC_URL + "/assets/images/facebook.svg"
                              }
                              alt=""
                              title=""
                              />
                              {t("cwf")}
                          </button>
                      </LoginSocialFacebook>
                  )}

                  {/* login with apple account */}
                  {location?.state?.rnRegisteredData?.saa === "T" &&(
                      <AppleLogin
                          clientId={process.env.REACT_APP_APPLE_CLIENT_ID}
                          redirectURI={process.env.REACT_APP_APPLE_REDIRECT_URI}
                          scope="name email"
                          usePopup={true}
                          callback={(resAppleLogin) => {
                              // console.log('resAppleLogin', resAppleLogin);

                              const token = resAppleLogin?.authorization?.id_token || "";
                              const decodedToken = jwt_decode(token);

                              // console.log('decodedToken', decodedToken);

                              if (!resAppleLogin?.error) {
                              const requestData = {
                                  loginid: decodedToken?.email || "",
                                  loginmode: "email",
                                  socialmediatype: "appleid",
                                  pwd: "",
                                  socialid: decodedToken?.sub || "",
                                  RM: "1",
                              };
                              setsocialtype("appleid");
                              validateLoginUrl.mutate(requestData);
                              }
                          }}
                          render={(renderProps) => {
                              return (
                              <button
                                  className="social_btn apple_btn mt-2"
                                  onClick={() => renderProps?.onClick()}
                              >
                                  <img
                                  src={
                                      process.env.PUBLIC_URL + "/assets/images/apple.svg"
                                  }
                                  alt=""
                                  title=""
                                  />
                                  {t("cwa")}
                              </button>
                              );
                          }}
                      />
                      
                  )}
                </div>
            </div> 
          </div>
        </div>
      </section>

      <section className="fixed_footer">
        <div className="fixed_footer_container">
          <button
            disabled={disabledButton || isApiCall}
            className="custom_btn custom_btn_primary btn_block"
            onClick={(event) => {
              validateOtpParams();
            }}
          >
            {
              isApiCall ? <Loadingcomponent /> : <>{t("continue")}</>
            }
          </button>
        </div>
      </section>

      <BottomModalComponent
        popuptype="success"
        show={showModal}
        respmessage={respMessage}
        togglebottomModal={toggleModal}
        shouldEnableBackdropClick={true}
      />
    </div>
  );
};
export default OTPLoginVerification;
